import * as React from "react";
import { SVGProps, memo } from "react";

const SvgAddSimple = (props: SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M9.25 17.207a.75.75 0 0 0 1.5 0v-6.5h6.5a.75.75 0 0 0 0-1.5h-6.5v-6.5a.75.75 0 0 0-1.5 0v6.5h-6.5a.75.75 0 0 0 0 1.5h6.5v6.5Z"
      fill="#637182"
    />
  </svg>
);

const Memo = memo(SvgAddSimple);

export default Memo;
